<template>
  <div class="task-response" data-qid="task-response">
    <div class="task-response__label">
      {{ $t('tasks.modal.response_label') }}
      <span v-if="selectedTask.add_response === 'Mandatory'" class="text-red">*</span>
    </div>
    <div v-if="selectedTask.response_type !== 'Datepicker'" class="task-choices">
      <span v-for="option in allAnswers"
            :key="'answer-' + option.title"
            class="task-choice"
            :style="choiceStyle(option)"
            :class="['task-choice--option', {'task-choice--on': selectedTask.response === option.title, 'disabled': !canEdit}]"
            @click="chooseAnswer(option)"
            data-qid="task-response-option"
      >
        <font-awesome-icon v-if="iconOf(option)"
                           :icon="iconOf(option).icon"
                           class="task-choice__icon"
                           :style="iconOf(option).style"
        />
        <font-awesome-icon v-else :icon="selectedTask.response === option.title ? 'dot-circle' : 'circle'"/>{{ option.title }}
      </span>
      <span class="task-choices__hint" v-if="canEdit">{{ selectedTask.response ? $t('tasks.v2.saved_when_clicked_clear') : $t('tasks.v2.saved_when_clicked') }}</span>
    </div>
    <div v-else class="task-choices">
      <datepicker v-model="selectedDate"
                  class="date-picker"
                  calendar-class="right"
                  :clear-button="canEdit"
                  :disabled="!canEdit"
                  :placeholder="$t('tasks.modal.response_label')"
      ></datepicker>
      <b-button v-if="canEdit"
                size="sm"
                variant="success"
                @click="updateResponse(selectedTask)">{{ $t('tasks.modal.save') }}</b-button>
    </div>
  </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Datepicker from 'vuejs-datepicker';
import { iconForOption } from './responseIcon';
import { optionStyle } from '@/util/dropdownOptions.js';

// The task's response (e.g. no / minor / significant deviations), saved when clicked
export default {
  name: 'EngagementTaskResponse',
  mixins: [assessmentSingleTaskProxy],
  components: {
    Datepicker
  },
  computed: {
    canEdit() {
      return this.selectedTask && !this.readOnly;
    }
  },
  methods: {
    // The icon and colour the option was given
    iconOf(option) {
      return iconForOption(option);
    },
    // Clicking the chosen answer again clears the response
    chooseAnswer(option) {
      if (!this.canEdit) {
        return;
      }
      this.selectedAnswer = this.selectedTask.response === option.title ? null : option;
      this.updateResponse(this.selectedTask);
    },
    // The chosen option is tinted in its own colour, like its pill on the template
    choiceStyle(option) {
      const style = optionStyle(option);
      return { '--c': style.hex, '--t': style.text };
    }
  }
};
</script>
